<template>
  <div class="bootstrap-wrapper">
    <div class="container">
      <DirPath :path="['Aplicar Diagnósticos']" />
      <div class="row align-center">
        <div class="col-md-12">
          <div class="row">
            <div class="text-barlow-condensed title">Aplicar Diagnósticos</div>
            <div class="text-barlow-condensed subtitle-2">
              <!-- Lorem ipsum. -->
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-6">
              <DropSelect
                v-bind="selectInstrumento"
                :icon="'file-search-alt'"
                :zIndex="2"
              />
            </div>

            <div class="col-md-6">
              <VueDatePicker v-model="date" :color="secCol">
                <template #activator="{ date }">
                  <DropSelect
                    :date="date"
                    :type="'datePicker'"
                    :supTitle="'Día a ejecutarse'"
                    :placeholder="'Seleccione el día'"
                    :icon="'schedule'"
                  />
                </template>
              </VueDatePicker>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-3 mx-auto text-center">
              <button class="button secondary">Agendar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <FooterComponent />
      </div>
    </div>
  </div>
</template>

<script>
import DirPath from "@/components/DirPath";
import FooterComponent from "@/components/Footer";
import DropSelect from "@/components/DropSelect";

export default {
  name: "diagnostics",
  components: {
    DirPath,
    FooterComponent,
    DropSelect,
  },
  data() {
    let { secCol } = this.$store.getters;

    return {
      secCol,
      date: null,
      selectInstrumento: {
        options: [
          {
            text: "Instrumento 1",
            value: "1",
          },
          {
            text: "Instrumento 2",
            value: "2",
          },
        ],
        placeholder: "Elegir intrumento de evaluación",
        supTitle: "Insctrumento de Evaluación",
        id: "instrumento",
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.secondary {
  width: calc(100% - 25px);
}
</style>
